// Štítek stavu připojení (práce bez signálu, 2026-10-31): bez signálu nebo
// když čekají neodeslané změny, ukáže se pod horním panelem pilulka
// „Bez signálu · 3 změny čekají“ / „Odesílám změny (3)…“. Klepnutí zkusí
// odeslat hned. Stav posílá supabase-layer.js (událost bozp-sync, __sync).
import { showToast } from './state.js';

function changesLabel(n){
  return n + (n===1 ? ' změna čeká' : (n>=2 && n<=4) ? ' změny čekají' : ' změn čeká');
}
function update(st){
  st = st || (window.__sync && window.__sync.state()) || {offline:false, pending:0};
  var el = document.getElementById('syncBadge');
  var show = st.offline || st.pending > 0;
  if(!show){ if(el) el.classList.remove('show'); return; }
  if(!el){
    el = document.createElement('button');
    el.id = 'syncBadge';
    el.type = 'button';
    el.className = 'sync-badge';
    el.addEventListener('click', function(){ if(window.__sync) window.__sync.flush(); });
    document.body.appendChild(el);
  }
  el.classList.toggle('offline', !!st.offline);
  el.textContent = st.offline
    ? ('Bez signálu' + (st.pending ? ' · ' + changesLabel(st.pending) : ' · změny se uloží v zařízení'))
    : ('Odesílám změny (' + st.pending + ')…');
  el.classList.add('show');
}
window.addEventListener('bozp-sync', function(e){ update(e.detail); });
window.addEventListener('online', function(){ update(); });
window.addEventListener('offline', function(){ update(); });
window.addEventListener('bozp-sync-error', function(e){
  var code = e.detail && e.detail.code;
  showToast(code==='42501' ? 'Změnu uloženou bez signálu server odmítl (oprávnění).' : 'Změnu uloženou bez signálu se nepodařilo odeslat.');
});
